import React from 'react';
import styled from 'styled-components';

import { thirdPartyModulesConfig } from './thirdPartyModulesConfig';
import { ModuleIcon } from './ModuleIcon';

export interface ModuleLabelProps {
  withTooltip?: boolean;
  module?: string;
  className?: string;
  style?: React.CSSProperties;
}

const Icon = styled(ModuleIcon)``;

const Container = styled.div`
  display: flex;
  gap: 6px;
  & ${Icon} {
    display: flex;
  }
`;

export const ModuleLabel: React.FC<ModuleLabelProps> = ({ module, className, style, withTooltip = false }) => {
  return (
    <Container className={className} style={style}>
      <Icon thirdPartyModule={module} withTooltip={withTooltip} />
      <span>{module && thirdPartyModulesConfig[module] ? thirdPartyModulesConfig[module].display : ''}</span>
    </Container>
  );
};
